import { render, staticRenderFns } from "./AIChatWidgetPdpParallelGrid.vue?vue&type=template&id=daec86f6&scoped=true"
import script from "./AIChatWidgetPdpParallelGrid.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetPdpParallelGrid.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetPdpParallelGrid.vue?vue&type=style&index=0&id=daec86f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daec86f6",
  null
  
)

export default component.exports